import { render, staticRenderFns } from "./Block5Creation.vue?vue&type=template&id=8ae2f018&scoped=true&"
import script from "./Block5Creation.vue?vue&type=script&lang=js&"
export * from "./Block5Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae2f018",
  null
  
)

export default component.exports